import { BaseModel } from "./base"
import { JsonProperty } from "../requests/jsonparser";
import { NewsProvider } from "./news_provider";
import { Album } from "./album";

export class NewsFeedItem extends BaseModel {

    @JsonProperty({ type: 'false' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'NewsFeedItem' })
    MODELNAME: string;


    @JsonProperty({ type: 'string' })
    id: string;

    @JsonProperty({ type: 'string' })
    title: string

    @JsonProperty({ type: 'string' })
    link: string

    @JsonProperty({ type: 'string?' })
    image_url?: string

    @JsonProperty({ type: 'Date' })
    posted_date: Date

    @JsonProperty({ type: 'string' })
    external_id: string

    @JsonProperty({ type: 'any' })
    tags: { title: string }[]

    @JsonProperty({ type: 'any' })
    song_mapping: {
        [key: string]: Album
    }

    @JsonProperty({ type: 'string' })
    rendered: string

    @JsonProperty({ type: 'string' })
    original_rendered: string

    @JsonProperty({ type: 'string' })
    slug: string;

    @JsonProperty({ type: 'any' })
    mappings: any

    @JsonProperty({ type: 'string?' })
    video_url?: string;

    @JsonProperty({ clazz: NewsProvider, type: 'NewsProvider' })
    provider: NewsProvider

}



// WEBPACK FOOTER //
// ./src/api/src/models/news_feed_item.ts